import { Card } from '@/globalComponents/card';
import React, { useContext, useEffect, useState } from 'react';
import { address } from '.';
import ServiceRequestInfo from '../../SubComponents/serviceRequestInfo';
import styles from './style.module.scss';
import Image from 'next/image';
import pendingRequest from '/public/images/pendingRequest.svg';
import { Icons } from '@/configs/icons';
import { Icon } from '@/globalComponents/Icon';
import { getTrackingStatus } from './utils';
import { ServiceRequestContext } from '@/context/serviceRequestContext';
import { StatusTrackingContext } from '@/context/statusTrackingContext';

export const orderObject = {
  dateAndTime: 'dateAndTime',
  serviceType: 'serviceType',
  defectType: 'defectType',
  address: 'address',
  description: 'addnRemarks',
  paymentStatus: 'paymentStatus',
};

const StatusTracking = (props: { defaultAddress: address }) => {
  const { defaultAddress } = props;
  const keyValueClassNames = `text-base md:text-base font-normal flex flex-col ${styles.keyText}`;
  const valueClassNames = `block font-medium text-lg md:font-normal ${styles.value}`;
  const { state: statusTrackingData } = useContext(StatusTrackingContext);
  const { requestStatus } = statusTrackingData;
  const label = getTrackingStatus(requestStatus);
  const { state: serviceState } = useContext(ServiceRequestContext);
  const { serviceRequestID } = serviceState;

  const [isMobileView, setMobileView] = useState(false);
  const [showAllDetails, setshowAllDetails] = useState(false);
  useEffect(() => {
    window.addEventListener('resize', resize);
    resize();
  }, []);

  const resize = () => {
    setMobileView(window.innerWidth < 1024);
  };

  return (
    <Card
      classNames={`flex flex-col w-full py-3 px-4 w-full md:px-6 md:py-4 lg:w-[50%] h-fit ${styles.reqCard}`}
    >
      <li className={`!flex-row justify-between ${keyValueClassNames} ${styles.listBorder}`}>
        <p>
          Service Request no.
          <span data-testid={'Service Request no.'} className={valueClassNames}>
            {serviceRequestID}
          </span>
        </p>
        <div className="flex flex-col items-center">
          <Image src={pendingRequest} alt="pending request icon" />
          <p className={`${styles.keyText}`} data-testid={'req-status-open'}>
            {label}
          </p>
        </div>
      </li>
      <ServiceRequestInfo
        valueClassNames={valueClassNames}
        listClassNames={`pt-[1rem] gap-5 md:pt-[1.5rem] flex flex-col text-sm md:text-base font-normal md:gap-s6 ${styles.key}`}
        defaultAddress={defaultAddress}
        order={
          isMobileView && !showAllDetails
            ? [orderObject.dateAndTime]
            : [
                orderObject.dateAndTime,
                orderObject.serviceType,
                orderObject.defectType,
                orderObject.description,
                orderObject.address,
                orderObject.paymentStatus,
              ]
        }
        statusTracking={true}
      />
      {isMobileView && (
        <button
          onClick={() => setshowAllDetails(!showAllDetails)}
          className={`self-end pt-4 ${styles.link}`}
        >
          {!showAllDetails ? (
            <div className="flex gap-s2 items-center text-[0.875rem] font-bold leading-4 text-[#4e9bff]">
              View more details{' '}
            </div>
          ) : (
            <div className="flex gap-s3 items-center text-[0.875rem] font-bold leading-4 text-[#4e9bff]">
              View less
            </div>
          )}
        </button>
      )}
    </Card>
  );
};

export default StatusTracking;
